// src/constants/SecurityUserType.js
export const SecurityUserType = Object.freeze({
  SuperAdmin: 1,
  CompanyAdmin: 2,
  Lawyer: 3,
  Client: 4,
});
